import { useTranslation } from 'react-i18next';
import {
  Grid,
} from '@mui/material';
import ListPageContainer from '../../components/ListPageContainer';
import { useAuth } from '../../hooks/useAuth';
import STRING_KEYS from '../../language/keys';
import { currentTimeToText } from '../../utils/date';
import Tasks from './TaskList';
import style from './style';
import SideStatistics from './SideStatistics';
import Statistics from './Statistics';

export default function HomePage(): JSX.Element {
  const { user } = useAuth();
  const { t: translate } = useTranslation();
  const partOfDayType = currentTimeToText();
  const partOfDayString = translate(STRING_KEYS.PARTS_OF_DAY[partOfDayType]);

  return (
    <ListPageContainer
      title={ {
        text: translate(STRING_KEYS.HOME_PAGE.TITLE, {
          name: `${user?.firstName} ${user?.lastName}`,
          partOfDay: partOfDayString,
        }),
      } }
    >
      <Grid container spacing={ 2 } sx={ style.gridContainer }>
        <Grid item xs={ 6 } md={ 8 }>
          <Statistics />
          <div style={ { marginTop: 40 } }><Tasks /></div>
        </Grid>
        <Grid item xs={ 6 } md={ 4 }>
          <SideStatistics />
        </Grid>
      </Grid>
    </ListPageContainer>
  );
}
